import { BaseRepository } from "@/repositories/base-repository"
import { type ISale } from "@/interfaces/api/sale.interface"
import { SaleItem } from "@/models/sale-item.model"
import { type Moment } from "moment"
import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder"

export class SaleRepository extends BaseRepository<ISale> {
  protected resourcePath = "administration/sales"

  public async applyPricesRetroactively(saleItem: SaleItem, retroactiveDate: Moment) {
    return new HTTPRequestBuilder(
      HTTPMethods.PUT,
      `${this.resourcePath}/apply-prices-retroactively/`
    )
      .setData({
        sale_item_id: saleItem.id,
        retroactive_date: retroactiveDate.format("YYYY-MM-DD")
      })
      .build()
      .execute()
  }
}
